/* eslint @typescript-eslint/no-duplicate-enum-values: off */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InitDataService } from '../system-services/InitData/InitData.service';

export enum SlackNotificationTypes {
    Unknown = '',
    FirstLogin = '',
    TeamMemberFirstLogin = '',
    AddedFirstTeamMember = '',
    MeetingBooked = '',
    ShareLinkCopy = '',
    ShareLinkView = '',
    DeisgnNoBAFirstLogin = '',
    DesignInlineBACompleted = '',
    DesignLimitedUserUpgraded = '',
    DesignBumperEmail = '',
    GlobalSearchInitiated = '',
    InspireSlackHookDev = '',
    InspireSlackHookProd = ''
}

export class SlackNotificationOptionalParameters {
    location?: string;
    jobCount?: number;
    unlockedCandidateCount?: number;
    baMilestoneCount?: number;
    jobName?: string;
    logRocketSessionId?: string;
    companyId: string;
    bumperEmailType?: string;
    searchQuery?: string;
    finishedInspireOnboarding?: boolean;

    constructor(obj?: Partial<SlackNotificationOptionalParameters>) {
        Object.assign(this, obj);
    }
}

/**
 * @deprecated The service should not be used as it is no longer supported due to
 *  potential security risks with storing webhook URLs client side.
 */
@Injectable({ providedIn: 'root' })
export class SlackNotificationService {
    constructor(
        private httpClient: HttpClient,
        private init: InitDataService
    ) {}

    /**
     * @deprecated The method should not be used as it is no longer supported due to
     *  potential security risks with storing webhook URLs client side.
     */
    callNotificationWebhook(
        notificationType: SlackNotificationTypes,
        slackNotificationOptionalParameters?: SlackNotificationOptionalParameters
    ) {
        return Promise.resolve();
    }
}
